import SelectWordBin from "./select-word-bin";

export default SelectWordBin;